import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDropzone } from "react-dropzone";
import commentIcon from "../../../../assets/svg/comment.svg";
import vector71Icon from "../../../../assets/svg/Vector 71.svg";
import viewIcon from "../../../../assets/svg/view.svg";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  CommentMetadata,
  Segment,
  Divider,
  Header,
  GridColumn,
  GridRow,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  List,
  Message,
  Popup,
  Dropdown,
} from "semantic-ui-react";
import { useFormik, Field, FieldArray, FormikProvider, getIn } from "formik";
import { Waterform, AuditLog } from "../../../../api";
const auditLogController = new AuditLog();
import { useAuth } from "../../../../hooks";
import { coins_units, ENV, PERIODS, units_8 } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./WaterForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import { convertPeriodsEngToEsp, t } from "../../../../utils/converts";
import "./WaterForm.scss";
import { useLanguage } from "../../../../contexts";
import { determineWaterUnits } from "../../../../utils/dataAndFormulas/waterForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
import { invoiceCurrencySymbol, formatInvoiceAmount, formatInvoiceQuantity, INVOICE_CURRENCY_BADGE_STYLE } from "../../../../utils/invoiceFormat";

const MAX_INVOICE_FILES = 20;
const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024; // 10 MB, igual que el backend
import {
  isAdmin,
  isEditor,
  isReviewer,
  isMaster,
} from "../../../../utils/checkPermission";

const waterFormController = new Waterform();

// Multi-medidor: clave normalizada para agrupar por nombre de medidor sin que
// mayúsculas/espacios generen medidores "distintos" por error de tipeo.
const normalizeMeterKey = (name) => (name || "").trim().toLowerCase();

const PERIOD_NUM_TO_NAME = {
  "01": "January", "1": "January",
  "02": "February", "2": "February",
  "03": "March", "3": "March",
  "04": "April", "4": "April",
  "05": "May", "5": "May",
  "06": "June", "6": "June",
  "07": "July", "7": "July",
  "08": "August", "8": "August",
  "09": "September", "9": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

export function WaterForm(props) {
  const {
    onClose,
    onReload,
    waterForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [newFiles, setNewFiles] = useState({});
  const [unitEditEnabled, setUnitEditEnabled] = useState(false);

  // Lector de facturas de agua
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [invoicePeriodMismatch, setInvoicePeriodMismatch] = useState(false);
  const [bulkSaveLoading, setBulkSaveLoading] = useState(false);
  const [bulkSaveResults, setBulkSaveResults] = useState(null);
  const [applyWarning, setApplyWarning] = useState(null);
  const [appliedIndexes, setAppliedIndexes] = useState(new Set());
  // Nombre de medidor por fila (_rowId) — solo se pide cuando hay 2+ facturas del mismo período
  const [meterNames, setMeterNames] = useState({});
  // Medidores ya usados en el sitio (para el selector, en vez de tipear a mano)
  const [existingMeterNames, setExistingMeterNames] = useState([]);
  // Elección doméstica/producción por fila (_rowId) — solo se pide cuando el
  // sitio tiene "combinada" desactivada y doméstica + producción activas a
  // la vez (no hay forma de saber a cuál corresponde la factura).
  const [sourceChoices, setSourceChoices] = useState({});
  const bulkSaveResultsRef = useRef(null);
  const invoiceInputRef = useRef(null);
  const pendingInvoicePeriodRef = useRef(null);
  const { user } = useAuth();

  // Verificar si el usuario puede editar unidades (admin o master)
  const canEditUnits = isAdmin(user.role) || isMaster(user.role);

  const location = useLocation();
  //const { siteSelected } = location.state || {};

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateWater = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")} ${data}`);
    onOpenCloseModal();
  };

  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }

  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved"
        ? "#d4edda"
        : approvalStatus === "rejected"
        ? "#f8d7da"
        : approvalStatus === "pending"
        ? "#fff3cd"
        : "white",
    color:
      approvalStatus === "approved"
        ? "#155724"
        : approvalStatus === "rejected"
        ? "#721c24"
        : approvalStatus === "pending"
        ? "#856404"
        : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1,
  });

  // Helper function para limpiar el valor 0 cuando se hace focus en el campo
  const handleFocusNumberInput = (e) => {
    const value = e.target.value;
    if (value === "0" || value === 0) {
      e.target.value = "";
    }
  };

  const formik = useFormik({
    initialValues: initialValues(waterForm, period, year, unitsRecorded),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            setNestedError(errors, e.path, e.message);
            formik.setFieldTouched(e.path, true, false);
          });

          // 🔹 Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);

          // 🔹 Scroll automático al primer error
          // 🔹 Scroll automático al primer error
          const firstErrorPath = err.inner[0]?.path;
          if (firstErrorPath) {
            const fieldId = firstErrorPath.replace(/\./g, "_");
            let fieldEl =
              document.getElementById(fieldId) ||
              document.querySelector(`[name="${firstErrorPath}"]`);

            if (!fieldEl) {
              fieldEl = Array.from(
                document.querySelectorAll("input, select, textarea")
              ).find(
                (el) =>
                  el.name?.includes(firstErrorPath) || el.id?.includes(fieldId)
              );
            }

            if (fieldEl) {
              // Buscar el contenedor con scroll
              let scrollContainer = fieldEl.parentElement;
              while (
                scrollContainer &&
                scrollContainer !== document.body &&
                scrollContainer.scrollHeight <= scrollContainer.clientHeight
              ) {
                scrollContainer = scrollContainer.parentElement;
              }

              // Calcular posición
              const rect = fieldEl.getBoundingClientRect();
              const offset = 150;

              if (scrollContainer && scrollContainer !== document.body) {
                const containerRect = scrollContainer.getBoundingClientRect();
                const scrollTopTarget =
                  scrollContainer.scrollTop +
                  (rect.top - containerRect.top) -
                  offset;
                scrollContainer.scrollTo({
                  top: scrollTopTarget,
                  behavior: "smooth",
                });
              } else {
                window.scrollTo({
                  top: rect.top + window.scrollY - offset,
                  behavior: "smooth",
                });
              }

              fieldEl.focus({ preventScroll: true });
            } else {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }
          }
        }
      }
      return errors;
    },
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!waterForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // } else {
            //   // Desencriptar los datos recibidos
            //   // if (!waterForm) {
            //   //   const siteData = decrypt(siteSelected);
            //   //   formValue.site = siteData;
            //   // }
            // }
          }
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          const response = await waterFormController.createWaterForm(
            accessToken,
            finalData
          );
          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente!.");
            // Enviar email de resumen en background (no bloquea el flujo)
            waterFormController.sendSummaryEmail(accessToken, {
              to: user.email,
              siteName: siteSelected || user?.site || "",
              period: formValue.period,
              year: formValue.year,
              volume: formValue.combined_municipal_network_water?.value,
              cost: formValue.water_cost_combined_municipal_network?.value,
            }).catch(() => {});
          }
          //console.log(formValue);
        } else {
          // Detectar cambios de unidad para auditoría (solo admin/master)
          if (isAdmin(user.role) || isMaster(user.role)) {
            const unitChanges = [];
            for (const fieldName in formValue) {
              if (formValue[fieldName]?.unit !== undefined && waterForm[fieldName]?.unit !== undefined) {
                if (formValue[fieldName].unit !== waterForm[fieldName].unit) {
                  unitChanges.push({
                    field: fieldName,
                    oldUnit: waterForm[fieldName].unit,
                    newUnit: formValue[fieldName].unit,
                    oldValue: waterForm[fieldName].value,
                    newValue: formValue[fieldName].value,
                  });
                }
              }
            }

            // Registrar cambios de unidad en auditoría
            for (const change of unitChanges) {
              try {
                await auditLogController.createAuditLog(accessToken, {
                  documentId: waterForm._id,
                  documentType: "water",
                  field: change.field,
                  oldValue: { value: change.oldValue, unit: change.oldUnit },
                  newValue: { value: change.newValue, unit: change.newUnit },
                  changeType: "unit_change",
                  changedBy: user._id,
                  site: waterForm.site?._id || waterForm.site,
                  company: waterForm.company,
                  year: waterForm.year,
                  period: waterForm.period,
                });
              } catch (auditError) {
                console.error("Error registrando auditoría:", auditError);
              }
            }

            if (unitChanges.length > 0) {
              toast.info(`${unitChanges.length} cambio(s) de unidad registrado(s) en auditoría`);
            }
          }

          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const finalData = removeNullValues(formValue);
          const response2 = await waterFormController.updateWaterForm(
            accessToken,
            waterForm._id,
            finalData
          );

          if (response2.code && response2.code === 200) {
            toast.success("Formulario guardado correctamente!.");
            // Enviar email de resumen en background (no bloquea el flujo)
            waterFormController.sendSummaryEmail(accessToken, {
              to: user.email,
              siteName: siteSelected || user?.site || "",
              period: formValue.period,
              year: formValue.year,
              volume: formValue.combined_municipal_network_water?.value,
              cost: formValue.water_cost_combined_municipal_network?.value,
            }).catch(() => {});
          }
        }

        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await waterFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  function removeNullValues(obj) {
    for (const key in obj) {
      if (typeof obj[key] === "object" && obj[key].hasOwnProperty("value")) {
        if (obj[key].value === "" || obj[key].value === null) {
          delete obj[key];
        }
      }
    }
    return obj;
  }

  const goBack = () => {
    navigate(`/admin/data/waterforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    if (files.length > MAX_INVOICE_FILES) {
      toast.error(t("too_many_invoice_files") || `Se permiten hasta ${MAX_INVOICE_FILES} archivos por carga`);
      return;
    }
    const oversized = files.find((f) => f.size > MAX_INVOICE_FILE_SIZE);
    if (oversized) {
      toast.error(`"${oversized.name}" ${t("file_exceeds_max_size") || "supera el tamaño máximo permitido (10MB)"}`);
      return;
    }
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await waterFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        // La lectura automática no está disponible en este momento (servicio
        // externo) y el regex tampoco pudo leer nada: no abrimos el preview.
        if (result.aiUnavailable) {
          toast.info(t("invoice_ai_unavailable") || "No pudimos leer la factura automáticamente en este momento. Volvé a intentar en unos minutos.");
          setShowUploadModal(false);
          return;
        }
        const validResults = result.results.filter(r => !r.error && r.period && r.year);
        const uniquePeriods = new Set(validResults.map(r => `${r.period}/${r.year}`));
        setInvoicePeriodMismatch(uniquePeriods.size > 1);
        // _rowId identifica cada fila de forma única: un mismo PDF puede
        // traer varias facturas y compartir "filename" entre varias filas.
        setInvoiceResults(result.results.map((r, i) => ({ ...r, _rowId: `${r.filename}#${i}` })));
        setAppliedIndexes(new Set());
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_water_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  const handleUnapplyInvoiceData = (result) => {
    if (!result) return;
    setAppliedIndexes(prev => {
      const next = new Set(prev);
      next.delete(result._rowId);
      return next;
    });
  };

  const applyPeriodAndYear = (result, periodName, yearNum) => {
    const yearIsChanging = yearNum && yearNum !== formik.values.year;
    if (yearNum) formik.setFieldValue("year", yearNum);

    if (periodName) {
      if (yearIsChanging) {
        pendingInvoicePeriodRef.current = periodName;
      } else {
        if (listPeriods.includes(periodName)) {
          formik.setFieldValue("period", periodName);
        } else {
          toast.warning(`El período ${t(periodName)} ya está cargado para este año.`);
        }
      }
    }
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;

    const periodName = result.period ? (PERIOD_NUM_TO_NAME[result.period] || result.period) : null;
    const yearNum = result.year ? parseInt(result.year, 10) : null;

    const target = resolveTargetFields(result.sourceType);
    const family = familyOf(result.sourceType);

    // Fuente simple detectada pero el sitio no tiene ese campo activo en su
    // configuración: no hay dónde aplicarla, se bloquea con aviso en vez de
    // escribir en un campo que el formulario ni siquiera muestra.
    if (target.mode === "blocked") {
      toast.warning(
        t("source_field_not_configured")
        || `Este sitio no tiene configurado el campo "${t(target.valueField) || target.valueField}".`
      );
      return;
    }

    // Doméstica o Producción (sin ambigüedad, o ya elegida), o fuente simple
    // sin desglose: campo directo, sin multi-medidor.
    if (target.mode === "direct" || target.mode === "choice") {
      const chosen = target.mode === "choice" ? resolveChosenFields(result._rowId, family) : target;
      if (!chosen) {
        toast.warning(t("source_choice_required") || "Elegí si esta factura es de consumo doméstico o de producción antes de aplicar.");
        return;
      }
      if (result.volume != null) formik.setFieldValue(`${chosen.valueField}.value`, result.volume);
      // Las fuentes simples no tienen costField (se ignora el costo por ahora).
      if (result.cost != null && chosen.costField) formik.setFieldValue(`${chosen.costField}.value`, result.cost);

      applyPeriodAndYear(result, periodName, yearNum);
      setAppliedIndexes(prev => new Set(prev).add(result._rowId));
      setApplyWarning(null);
      toast.success(t("invoice_data_applied"));
      return;
    }

    // mode === "combined": comportamiento existente, con multi-medidor.
    const periodKey = periodName && yearNum ? `${yearNum}-${periodName}` : null;

    // ¿Ya hay otra factura aplicada para el mismo período Y la misma fuente
    // (municipal/pozo)? Dos facturas del mismo mes pero de fuentes distintas
    // no compiten entre sí — van a tríos de campos separados.
    const conflicting = periodKey ? invoiceResults.find(r =>
      r._rowId !== result._rowId &&
      appliedIndexes.has(r._rowId) &&
      r.period && r.year &&
      familyOf(r.sourceType) === family &&
      `${parseInt(r.year, 10)}-${PERIOD_NUM_TO_NAME[String(r.period)] || r.period}` === periodKey
    ) : null;

    const meterName = (meterNames[result._rowId] || "").trim();
    if (conflicting && !meterName) {
      toast.warning(t("meter_name_required") || "Ingresá un nombre de medidor para agregar este registro.");
      return;
    }

    // Agrega (o inicia) el desglose por medidor de un campo, y recalcula su total.
    // Idempotencia: si ya hay un registro con el mismo sourceHash (mismo
    // archivo ya aplicado antes), no se duplica. El primer valor de un
    // período (antes de que exista records[]) también guarda su sourceHash
    // como campo simple — si no se hiciera, esa primera factura no tendría
    // forma de detectarse como duplicada si se reaplica más adelante como medidor.
    let skippedDuplicate = false;
    const addAsMeterRecord = (fieldName, value) => {
      // fieldName puede ser undefined (fuentes simples no tienen costField) —
      // sin esto se terminaría escribiendo en formik.values["undefined"].
      if (value == null || !fieldName) return;
      const current = formik.values[fieldName] || {};
      const defaultMeterLabel = t("meter_default") !== "meter_default" ? t("meter_default") : "Medidor 1";
      const prevRecords = current.records?.length
        ? current.records
        : (current.value != null
            ? [{
                meterName: current.filename || defaultMeterLabel,
                value: current.value,
                source: current.sourceHash ? "invoice_reader" : "manual",
                filename: current.filename,
                sourceHash: current.sourceHash,
              }]
            : []);

      if (result.sourceHash && prevRecords.some((r) => r.sourceHash === result.sourceHash)) {
        skippedDuplicate = true;
        return;
      }

      const newRecords = [...prevRecords, { meterName, value, source: "invoice_reader", filename: result.filename, sourceHash: result.sourceHash, addedBy: user?._id }];
      formik.setFieldValue(`${fieldName}.records`, newRecords);
      formik.setFieldValue(`${fieldName}.value`, newRecords.reduce((s, r) => s + (r.value || 0), 0));
    };

    if (conflicting) {
      addAsMeterRecord(target.valueField, result.volume);
      addAsMeterRecord(target.costField, result.cost);
      if (skippedDuplicate) {
        toast.warning(t("meter_record_already_applied") || "Esta factura ya se había agregado como registro — no se duplicó.");
        return;
      }
    } else {
      if (result.volume != null) {
        formik.setFieldValue(`${target.valueField}.value`, result.volume);
        formik.setFieldValue(`${target.valueField}.sourceHash`, result.sourceHash);
        formik.setFieldValue(`${target.valueField}.filename`, result.filename);
      }
      if (result.cost != null && target.costField) {
        formik.setFieldValue(`${target.costField}.value`, result.cost);
        formik.setFieldValue(`${target.costField}.sourceHash`, result.sourceHash);
        formik.setFieldValue(`${target.costField}.filename`, result.filename);
      }
    }

    applyPeriodAndYear(result, periodName, yearNum);

    // A diferencia de antes, no se desaplica la factura en conflicto: ambas
    // quedan aplicadas porque ahora se suman como registros de medidores distintos.
    setAppliedIndexes(prev => new Set(prev).add(result._rowId));
    setApplyWarning(null);
    toast.success(t("invoice_data_applied"));
  };

  const handleSaveAllInvoiceData = async (overrideList) => {
    const source = Array.isArray(overrideList)
      ? overrideList
      : invoiceResults.filter(r => !r.error && r.period && r.year && appliedIndexes.has(r._rowId));
    const validResults = source.filter(r => r.period && r.year);
    if (!validResults.length) {
      toast.warning(t("no_valid_results_to_save") || "No hay resultados válidos para guardar.");
      return;
    }

    setBulkSaveLoading(true);
    setBulkSaveResults(null);

    const siteId = siteSelected || user?.site;
    const summary = { saved: [], skipped: [], errors: [] };

    // Agrupar por período+año
    const groups = new Map();
    for (const result of validResults) {
      const periodName = PERIOD_NUM_TO_NAME[String(result.period)] || result.period;
      const yearNum    = parseInt(result.year, 10);
      const key = `${yearNum}-${periodName}`;
      if (!groups.has(key)) groups.set(key, { periodName, yearNum, results: [] });
      groups.get(key).results.push(result);
    }

    // Arma el desglose por medidor de un grupo para un campo (volume/cost), a
    // partir de los resultados de este lote + lo que ya hubiera guardado.
    // Idempotencia: descarta resultados cuyo sourceHash ya esté entre los
    // registros existentes (mismo archivo ya guardado — reintento).
    const buildRecords = (results, key, existingRecords) => {
      const existingHashes = new Set((existingRecords || []).map((r) => r.sourceHash).filter(Boolean));
      const own = results
        .filter(r => r[key] != null && !(r.sourceHash && existingHashes.has(r.sourceHash)))
        .map((r, i) => ({
          meterName: (meterNames[r._rowId] || r.filename || `${t("meter") !== "meter" ? t("meter") : "Medidor"} ${i + 1}`).trim(),
          value: r[key],
          source: "invoice_reader",
          filename: r.filename,
          sourceHash: r.sourceHash,
          addedBy: user?._id,
        }));
      return [...(existingRecords || []), ...own];
    };

    // Arma los campos a guardar para un subconjunto de resultados que
    // comparten la misma familia (municipal, pozo, o una fuente simple)
    // dentro de un mismo grupo período+año. Devuelve un objeto parcial para
    // mezclar en waterFields.
    const buildWaterFieldsForFamily = async (results, family, existsResponse) => {
      const target = resolveTargetFields(family);
      const waterFields = {};

      // Bloqueada (fuente simple sin campo activo en el sitio): no debería
      // llegar acá porque handleApplyInvoiceData ya la frena al aplicar, pero
      // por las dudas no se guarda nada.
      if (target.mode === "blocked") return waterFields;

      // Water.findByIdAndUpdate con un objeto parcial hace $set sobre el
      // subdocumento COMPLETO del campo — reemplaza todo lo que tenía antes
      // (unit, code, approvalStatus, reviews, files), no solo "value"/"records".
      // Si acá no se preserva "unit", se borra la unidad ya configurada (ej.
      // vía "Configurar unidades") y el dashboard deja de sumar ese campo.
      // Por eso se trae el documento existente una sola vez y se conserva su
      // unit/code/approvalStatus/reviews/files en cada campo que se escribe.
      let existingDoc = null;
      if (existsResponse?.exist) {
        existingDoc = await waterFormController.getWaterForm(accessToken, existsResponse.id);
      }
      const preserved = (fieldName) => {
        const prev = existingDoc?.[fieldName];
        return {
          ...(prev?.code !== undefined ? { code: prev.code } : {}),
          unit: prev?.unit || unitsRecorded?.[fieldName] || "",
          ...(prev?.approvalStatus !== undefined ? { approvalStatus: prev.approvalStatus } : {}),
          ...(prev?.reviews !== undefined ? { reviews: prev.reviews } : {}),
          ...(prev?.files !== undefined ? { files: prev.files } : {}),
        };
      };

      if (target.mode !== "combined") {
        // Doméstica / Producción, o fuente simple: sin multi-medidor (esos
        // campos no tienen desglose por medidor). Si el modo es "choice",
        // cada resultado puede apuntar a un campo distinto según lo que se
        // haya elegido al aplicarlo — última carga gana por campo, como
        // siempre fue doméstica/producción antes de que existiera multi-medidor.
        for (const r of results) {
          const chosen = target.mode === "choice" ? resolveChosenFields(r._rowId, family) : target;
          if (!chosen) continue; // sin elección hecha, se omite (no debería pasar si se validó al aplicar)
          if (r.volume != null) waterFields[chosen.valueField] = { ...preserved(chosen.valueField), value: r.volume };
          // Las fuentes simples no tienen costField (se ignora el costo por ahora).
          if (r.cost != null && chosen.costField) waterFields[chosen.costField] = { ...preserved(chosen.costField), value: r.cost };
        }
        return waterFields;
      }

      // Si un campo ya tenía un valor simple guardado (sin records[] — la
      // primera factura de un período), lo convierte en el primer registro
      // antes de promoverlo a multi-medidor, arrastrando su sourceHash para
      // que la deduplicación lo siga reconociendo si se reaplica más tarde.
      const defaultMeterLabel = t("meter_default") !== "meter_default" ? t("meter_default") : "Medidor 1";
      const synthesizeRecords = (fieldName) => {
        const prev = existingDoc?.[fieldName];
        if (prev?.records?.length) return prev.records;
        if (prev?.value != null) {
          return [{
            meterName: prev.filename || defaultMeterLabel,
            value: prev.value,
            source: prev.sourceHash ? "invoice_reader" : "manual",
            filename: prev.filename,
            sourceHash: prev.sourceHash,
          }];
        }
        return [];
      };

      // Si hay un solo resultado en el grupo y el período no tenía medidores
      // previos, se guarda como valor simple (comportamiento de siempre).
      // Si hay 2+ resultados, o ya había un desglose por medidor guardado,
      // se arma/actualiza el array de registros y el total se recalcula.
      const existingVolumeRecords = synthesizeRecords(target.valueField);
      const existingCostRecords   = synthesizeRecords(target.costField);

      const needsVolumeRecords = results.length > 1 || existingVolumeRecords.length > 0;
      // Las fuentes simples no tienen costField (se ignora el costo por ahora).
      const needsCostRecords   = !!target.costField && (results.length > 1 || existingCostRecords.length > 0);
      const last = results[results.length - 1];

      if (needsVolumeRecords) {
        const allRecords = buildRecords(results, "volume", existingVolumeRecords);
        if (allRecords.length > 0) {
          waterFields[target.valueField] = {
            ...preserved(target.valueField),
            records: allRecords,
            value: allRecords.reduce((s, r) => s + (r.value || 0), 0),
          };
        }
      } else if (last.volume != null) {
        waterFields[target.valueField] = { ...preserved(target.valueField), value: last.volume, sourceHash: last.sourceHash, filename: last.filename };
      }

      if (needsCostRecords) {
        const allRecords = buildRecords(results, "cost", existingCostRecords);
        if (allRecords.length > 0) {
          waterFields[target.costField] = {
            ...preserved(target.costField),
            records: allRecords,
            value: allRecords.reduce((s, r) => s + (r.value || 0), 0),
          };
        }
      } else if (target.costField && last.cost != null) {
        waterFields[target.costField] = { ...preserved(target.costField), value: last.cost, sourceHash: last.sourceHash, filename: last.filename };
      }

      return waterFields;
    };

    for (const { periodName, yearNum, results } of groups.values()) {
      try {
        const existsResponse = await waterFormController.existsWaterFormByPeriodAndYear(
          accessToken, siteId, periodName, yearNum
        );

        // Un mismo grupo período+año puede mezclar facturas de distintas
        // fuentes (municipal, pozo, lluvia, etc. — ej. dos medidores subidos
        // juntos el mismo mes) — se procesan por separado, por familia, y se
        // combinan en el mismo payload.
        const resultsByFamily = new Map();
        for (const r of results) {
          const fam = familyOf(r.sourceType);
          if (!resultsByFamily.has(fam)) resultsByFamily.set(fam, []);
          resultsByFamily.get(fam).push(r);
        }

        const waterFields = {};
        for (const [fam, famResults] of resultsByFamily) {
          Object.assign(waterFields, await buildWaterFieldsForFamily(famResults, fam, existsResponse));
        }

        if (existsResponse?.exist) {
          await waterFormController.updateWaterForm(accessToken, existsResponse.id, waterFields);
        } else {
          const payload = initialValues(null, periodName, yearNum, unitsRecorded);
          payload.creator_user = user._id;
          payload.date = new Date();
          payload.site = siteId;
          Object.assign(payload, waterFields);
          await waterFormController.createWaterForm(accessToken, payload);
        }

        results.forEach(r => summary.saved.push({ period: periodName, year: yearNum, filename: r.filename }));
      } catch (err) {
        results.forEach(r => summary.errors.push({ period: periodName, year: yearNum, filename: r.filename, msg: err?.msg || err?.message }));
      }
    }

    setBulkSaveLoading(false);
    setBulkSaveResults(summary);
    if (summary.saved.length > 0) onReload?.();
    setTimeout(() => {
      const el = bulkSaveResultsRef.current;
      if (!el) return;
      const scrollContainer =
        el.closest(".scrolling.content") ||
        el.closest(".modal .content") ||
        el.closest(".content");
      if (scrollContainer) {
        scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: "smooth" });
      } else {
        el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 100);
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  useEffect(() => {
    (async () => {
      try {
        const response =
          await waterFormController.getPeriodsWaterFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }

        // Aplicar periodo pendiente desde lectura de documento
        if (pendingInvoicePeriodRef.current) {
          const pending = pendingInvoicePeriodRef.current;
          pendingInvoicePeriodRef.current = null;
          if (availablePeriods.includes(pending)) {
            formik.setFieldValue("period", pending);
          } else {
            toast.warning(`El período ${t(pending)} ya está cargado para el año ${formik.values.year}.`);
          }
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
        pendingInvoicePeriodRef.current = null;
      }
    })();
  }, [formik.values.year]);

  // Medidores ya usados en el sitio — para ofrecerlos en el selector del
  // lector de facturas en vez de que el usuario tenga que tipear el nombre.
  useEffect(() => {
    if (!showInvoiceModal) return;
    const siteId = siteSelected || user?.site;
    if (!siteId) return;
    (async () => {
      try {
        const years = [...new Set([
          formik.values.year,
          formik.values.year - 1,
        ].filter(Boolean))];
        const responses = await Promise.all(
          years.map((y) => waterFormController.getWaterFormsBySiteAndYear(accessToken, siteId, y).catch(() => null))
        );
        const seen = new Map();
        responses.forEach((response) => {
          (response?.waterForms || []).forEach((form) => {
            [
              ...(form.combined_municipal_network_water?.records || []),
              ...(form.water_cost_combined_municipal_network?.records || []),
              ...(form.groundwater_combined?.records || []),
              ...(form.groundwater_combined_cost?.records || []),
              ...(form.rainwater?.records || []),
              ...(form.surface_water?.records || []),
              ...(form.distilled_water?.records || []),
              ...(form.reused_water?.records || []),
              ...(form.recycled_water?.records || []),
              ...(form.steam_condensed_water?.records || []),
            ].forEach((r) => {
              const key = normalizeMeterKey(r.meterName);
              if (key && !seen.has(key)) seen.set(key, r.meterName.trim());
            });
          });
        });
        setExistingMeterNames(Array.from(seen.values()).sort());
      } catch (error) {
        console.error(error);
        setExistingMeterNames([]);
      }
    })();
  }, [showInvoiceModal, formik.values.year, siteSelected]);

  function findActiveFieldByName(nameToFind) {
    console.log("nameToFind", nameToFind, configFormData);
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      const field = configFormData.fields.find((f) => f.name === nameToFind);
      // Si el campo existe en configForm, verificar que active sea true
      if (field) {
        return field.active === true;
      }
      // Si el campo no existe en configForm, no mostrarlo
      return false;
    }
    // Si no hay configFormData, mostrar todos los campos por defecto
    return true;
  }

  // Lector de facturas — a qué campo de "red municipal" aplicar según qué
  // campos estén activos para el sitio (combinada / doméstica / producción).
  // Agua subterránea queda fuera de este cálculo: el lector sigue asumiendo
  // siempre red municipal, igual que hoy.
  //   mode "combined" → aplica a combinada (comportamiento de siempre, con
  //     multi-medidor).
  //   mode "direct"   → solo doméstica o solo producción está activa, no hay
  //     ambigüedad: aplica directo ahí, sin multi-medidor (esos campos no
  //     tienen desglose por medidor).
  //   mode "choice"   → doméstica y producción están activas a la vez (y
  //     combinada no): hay que preguntarle al usuario a cuál corresponde.
  function resolveMunicipalTargetFields() {
    const combinedActive = findActiveFieldByName("combined_municipal_network_water");
    if (combinedActive) {
      return { mode: "combined", valueField: "combined_municipal_network_water", costField: "water_cost_combined_municipal_network" };
    }
    const domesticActive = findActiveFieldByName("water_domestic_municipal_network");
    const productionActive = findActiveFieldByName("municipal_network_water_production");
    if (domesticActive && productionActive) {
      return { mode: "choice" };
    }
    if (domesticActive) {
      return { mode: "direct", valueField: "water_domestic_municipal_network", costField: "water_cost_domestic_municipal_network" };
    }
    if (productionActive) {
      return { mode: "direct", valueField: "municipal_network_water_production", costField: "water_cost_municipal_network_production" };
    }
    // Ninguno de los tres está activo (configuración atípica) — no rompemos
    // el comportamiento de siempre, se sigue asumiendo combinada.
    return { mode: "combined", valueField: "combined_municipal_network_water", costField: "water_cost_combined_municipal_network" };
  }

  // Mismo cálculo que resolveMunicipalTargetFields, pero para el trío de
  // agua subterránea (domestic_groundwater / groundwater_production /
  // groundwater_combined). Agua subterránea combinada sí soporta
  // multi-medidor (records[]), igual que la red municipal combinada.
  function resolveGroundwaterTargetFields() {
    const combinedActive = findActiveFieldByName("groundwater_combined");
    if (combinedActive) {
      return { mode: "combined", valueField: "groundwater_combined", costField: "groundwater_combined_cost" };
    }
    const domesticActive = findActiveFieldByName("domestic_groundwater");
    const productionActive = findActiveFieldByName("groundwater_production");
    if (domesticActive && productionActive) {
      return { mode: "choice" };
    }
    if (domesticActive) {
      return { mode: "direct", valueField: "domestic_groundwater", costField: "domestic_groundwater_cost" };
    }
    if (productionActive) {
      return { mode: "direct", valueField: "groundwater_production", costField: "groundwater_production_cost" };
    }
    return { mode: "combined", valueField: "groundwater_combined", costField: "groundwater_combined_cost" };
  }

  // Fuentes "simples": un solo campo, sin doméstica/producción/combinada, y
  // (por ahora) sin campo de costo — el costo detectado en la factura se
  // ignora para estas seis. Sí soportan multi-medidor (records[]), igual que
  // combinada municipal/pozo — "costField" queda undefined a propósito, y
  // todo el código de modo "combined" tiene que tolerar eso. Si el campo no
  // está activo para el sitio, no se aplica: se bloquea con aviso en vez de
  // escribir en un campo que el sitio no usa (podría quedar "invisible"
  // porque el campo no se renderiza).
  const SIMPLE_SOURCE_FIELDS = {
    rainwater: "rainwater",
    surface_water: "surface_water",
    distilled_water: "distilled_water",
    reused_water: "reused_water",
    recycled_water: "recycled_water",
    steam_condensed_water: "steam_condensed_water",
  };

  function resolveSimpleTargetFields(sourceType) {
    const valueField = SIMPLE_SOURCE_FIELDS[sourceType];
    return findActiveFieldByName(valueField)
      ? { mode: "combined", valueField, costField: undefined }
      : { mode: "blocked", valueField };
  }

  // Despacha según el sourceType detectado por el lector para esa factura
  // puntual. Default "municipal" — cualquier resultado sin sourceType (o con
  // un valor no reconocido) se comporta exactamente igual que antes de que
  // existiera este despacho.
  function resolveTargetFields(sourceType) {
    if (sourceType === "groundwater") return resolveGroundwaterTargetFields();
    if (SIMPLE_SOURCE_FIELDS[sourceType]) return resolveSimpleTargetFields(sourceType);
    return resolveMunicipalTargetFields();
  }

  // Agrupa un sourceType en su "familia" para efectos de conflicto de
  // período y de guardado en lote: groundwater y cada fuente simple son su
  // propia familia (no compiten entre sí ni con municipal); todo lo demás
  // (incluido undefined) cae en "municipal", igual que siempre.
  function familyOf(sourceType) {
    if (sourceType === "groundwater" || SIMPLE_SOURCE_FIELDS[sourceType]) return sourceType;
    return "municipal";
  }

  function resolveChosenFields(rowId, family = "municipal") {
    const choice = sourceChoices[rowId];
    if (!choice) return null;
    if (family === "groundwater") {
      return choice === "domestic"
        ? { valueField: "domestic_groundwater", costField: "domestic_groundwater_cost" }
        : { valueField: "groundwater_production", costField: "groundwater_production_cost" };
    }
    return choice === "domestic"
      ? { valueField: "water_domestic_municipal_network", costField: "water_cost_domestic_municipal_network" }
      : { valueField: "municipal_network_water_production", costField: "water_cost_municipal_network_production" };
  }

  return (
    <Form className="water-form" onSubmit={formik.handleSubmit}>
      {waterForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {waterForm.date ? formatDateView(waterForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {waterForm.creator_user
              ? waterForm.creator_user.lastname
                ? waterForm.creator_user.lastname + " " + waterForm.creator_user.firstname
                : waterForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!waterForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                      name="year"
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      name="period"
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !waterForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      {/* Botón para habilitar edición de unidades (solo admin/master en modo edición) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
        {canEditUnits && waterForm ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              type="button"
              color={unitEditEnabled ? "orange" : "grey"}
              size="small"
              icon
              labelPosition="left"
              onClick={() => setUnitEditEnabled(!unitEditEnabled)}
            >
              <Icon name={unitEditEnabled ? "unlock" : "lock"} />
              {unitEditEnabled
                ? (t("disable_unit_edit") || "Deshabilitar edición de unidades")
                : (t("enable_unit_edit") || "Habilitar edición de unidades")
              }
            </Button>
            {unitEditEnabled && (
              <Message warning size="tiny" style={{ margin: 0, padding: "8px 12px" }}>
                <Icon name="warning sign" />
                {t("unit_edit_warning") || "Los cambios de unidad se registrarán en auditoría"}
              </Message>
            )}
          </div>
        ) : <div />}
        <Popup
          content={t("read_water_invoice_tooltip") || "Leer factura de agua"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        />
      </div>
      <Table className="water-form-table" unstackable
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              width="1"
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="6"
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("concept")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("value")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("unit")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("state")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width={2}
              style={{ fontWeight: "bold", textAlign: "center", color: "#555" }}
            >
              {t("actions")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {findActiveFieldByName("water_domestic_municipal_network") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.water_domestic_municipal_network.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("water_domestic_municipal_network")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="water_domestic_municipal_network.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.water_domestic_municipal_network.value}
                  error={formik.errors.water_domestic_municipal_network?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.water_domestic_municipal_network?.unit &&
                    formik.touched.water_domestic_municipal_network?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.water_domestic_municipal_network.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "water_domestic_municipal_network"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "water_domestic_municipal_network.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "water_domestic_municipal_network.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "water_domestic_municipal_network.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.water_domestic_municipal_network.unit}
                    error={
                      !!formik.errors.water_domestic_municipal_network?.unit &&
                      !!formik.touched.water_domestic_municipal_network?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.water_domestic_municipal_network?.unit &&
                        formik.touched.water_domestic_municipal_network?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="water_domestic_municipal_network.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "water_domestic_municipal_network.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.water_domestic_municipal_network
                      .approvalStatus
                  }
                  error={
                    formik.errors.water_domestic_municipal_network
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.water_domestic_municipal_network
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.water_domestic_municipal_network.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("water_domestic_municipal_network"),
                          "water_domestic_municipal_network"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"water_domestic_municipal_network"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("municipal_network_water_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.municipal_network_water_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("municipal_network_water_production")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="municipal_network_water_production.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.municipal_network_water_production.value}
                  error={
                    formik.errors.municipal_network_water_production?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.municipal_network_water_production?.unit &&
                    formik.touched.municipal_network_water_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.municipal_network_water_production.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "municipal_network_water_production"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "municipal_network_water_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "municipal_network_water_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "municipal_network_water_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.municipal_network_water_production.unit
                    }
                    error={
                      !!formik.errors.municipal_network_water_production
                        ?.unit &&
                      !!formik.touched.municipal_network_water_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.municipal_network_water_production
                          ?.unit &&
                        formik.touched.municipal_network_water_production?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="municipal_network_water_production.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "municipal_network_water_production.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.municipal_network_water_production
                      .approvalStatus
                  }
                  error={
                    formik.errors.municipal_network_water_production
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.municipal_network_water_production
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.municipal_network_water_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("municipal_network_water_production"),
                          "municipal_network_water_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"municipal_network_water_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("combined_municipal_network_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.combined_municipal_network_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("combined_municipal_network_water")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="combined_municipal_network_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.combined_municipal_network_water.value}
                  error={formik.errors.combined_municipal_network_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.combined_municipal_network_water?.unit &&
                    formik.touched.combined_municipal_network_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.combined_municipal_network_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "combined_municipal_network_water"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "combined_municipal_network_water.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "combined_municipal_network_water.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "combined_municipal_network_water.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.combined_municipal_network_water.unit}
                    error={
                      !!formik.errors.combined_municipal_network_water?.unit &&
                      !!formik.touched.combined_municipal_network_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.combined_municipal_network_water?.unit &&
                        formik.touched.combined_municipal_network_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="combined_municipal_network_water.unit"
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "combined_municipal_network_water.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.combined_municipal_network_water
                      .approvalStatus
                  }
                  error={
                    formik.errors.combined_municipal_network_water
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.combined_municipal_network_water
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.combined_municipal_network_water.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("combined_municipal_network_water"),
                          "combined_municipal_network_water"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"combined_municipal_network_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("water_cost_domestic_municipal_network") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.water_cost_domestic_municipal_network.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("water_cost_domestic_municipal_network")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="water_cost_domestic_municipal_network.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={
                    formik.values.water_cost_domestic_municipal_network.value
                  }
                  error={
                    formik.errors.water_cost_domestic_municipal_network?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.water_cost_domestic_municipal_network?.unit &&
                    formik.touched.water_cost_domestic_municipal_network
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.water_cost_domestic_municipal_network
                            .unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "water_cost_domestic_municipal_network"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "water_cost_domestic_municipal_network.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "water_cost_domestic_municipal_network.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "water_cost_domestic_municipal_network.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.water_cost_domestic_municipal_network.unit
                    }
                    error={
                      !!formik.errors.water_cost_domestic_municipal_network
                        ?.unit &&
                      !!formik.touched.water_cost_domestic_municipal_network
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.water_cost_domestic_municipal_network
                          ?.unit &&
                        formik.touched.water_cost_domestic_municipal_network
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="water_cost_domestic_municipal_network.unit"
                  />
                </div>
                {/* {formik.values.water_cost_domestic_municipal_network.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "water_cost_domestic_municipal_network.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.water_cost_domestic_municipal_network
                      .approvalStatus
                  }
                  error={
                    formik.errors.water_cost_domestic_municipal_network
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.water_cost_domestic_municipal_network
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.water_cost_domestic_municipal_network.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("water_cost_domestic_municipal_network"),
                          "water_cost_domestic_municipal_network"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"water_cost_domestic_municipal_network"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("water_cost_municipal_network_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.water_cost_municipal_network_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("water_cost_municipal_network_production")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="water_cost_municipal_network_production.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={
                    formik.values.water_cost_municipal_network_production.value
                  }
                  error={
                    formik.errors.water_cost_municipal_network_production?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.water_cost_municipal_network_production
                    ?.unit &&
                    formik.touched.water_cost_municipal_network_production
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.water_cost_municipal_network_production
                            .unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "water_cost_municipal_network_production"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "water_cost_municipal_network_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "water_cost_municipal_network_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "water_cost_municipal_network_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.water_cost_municipal_network_production.unit
                    }
                    error={
                      !!formik.errors.water_cost_municipal_network_production
                        ?.unit &&
                      !!formik.touched.water_cost_municipal_network_production
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.water_cost_municipal_network_production
                          ?.unit &&
                        formik.touched.water_cost_municipal_network_production
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="water_cost_municipal_network_production.unit"
                  />
                </div>
                {/* {formik.values.water_cost_municipal_network_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "water_cost_municipal_network_production.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.water_cost_municipal_network_production
                      .approvalStatus
                  }
                  error={
                    formik.errors.water_cost_municipal_network_production
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.water_cost_municipal_network_production
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.water_cost_municipal_network_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("water_cost_municipal_network_production"),
                          "water_cost_municipal_network_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"water_cost_municipal_network_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("water_cost_combined_municipal_network") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.water_cost_combined_municipal_network.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("water_cost_combined_municipal_network")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="water_cost_combined_municipal_network.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={
                    formik.values.water_cost_combined_municipal_network.value
                  }
                  error={
                    formik.errors.water_cost_combined_municipal_network?.value
                  }
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.water_cost_combined_municipal_network?.unit &&
                    formik.touched.water_cost_combined_municipal_network
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors.water_cost_combined_municipal_network
                            .unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "water_cost_combined_municipal_network"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "water_cost_combined_municipal_network.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "water_cost_combined_municipal_network.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "water_cost_combined_municipal_network.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.water_cost_combined_municipal_network.unit
                    }
                    error={
                      !!formik.errors.water_cost_combined_municipal_network
                        ?.unit &&
                      !!formik.touched.water_cost_combined_municipal_network
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.water_cost_combined_municipal_network
                          ?.unit &&
                        formik.touched.water_cost_combined_municipal_network
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="water_cost_combined_municipal_network.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "water_cost_combined_municipal_network.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.water_cost_combined_municipal_network
                      .approvalStatus
                  }
                  error={
                    formik.errors.water_cost_combined_municipal_network
                      ?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.water_cost_combined_municipal_network
                      .approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.surface_water.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("water_cost_combined_municipal_network"),
                          "water_cost_combined_municipal_network"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"water_cost_combined_municipal_network"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("domestic_groundwater") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.domestic_groundwater.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("domestic_groundwater")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="domestic_groundwater.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.domestic_groundwater.value}
                  error={formik.errors.domestic_groundwater?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.domestic_groundwater?.unit &&
                    formik.touched.domestic_groundwater?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.domestic_groundwater.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("domestic_groundwater").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "domestic_groundwater.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "domestic_groundwater.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "domestic_groundwater.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.domestic_groundwater.unit}
                    error={
                      !!formik.errors.domestic_groundwater?.unit &&
                      !!formik.touched.domestic_groundwater?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.domestic_groundwater?.unit &&
                        formik.touched.domestic_groundwater?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="domestic_groundwater.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "domestic_groundwater.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.domestic_groundwater.approvalStatus}
                  error={formik.errors.domestic_groundwater?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.domestic_groundwater.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.network_water.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("domestic_groundwater"),
                          "domestic_groundwater"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"domestic_groundwater"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("groundwater_production") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.groundwater_production.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("groundwater_production")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="groundwater_production.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.groundwater_production.value}
                  error={formik.errors.groundwater_production?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.groundwater_production?.unit &&
                    formik.touched.groundwater_production?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.groundwater_production.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("groundwater_production").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "groundwater_production.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "groundwater_production.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "groundwater_production.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.groundwater_production.unit}
                    error={
                      !!formik.errors.groundwater_production?.unit &&
                      !!formik.touched.groundwater_production?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.groundwater_production?.unit &&
                        formik.touched.groundwater_production?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="groundwater_production.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "groundwater_production.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.groundwater_production.approvalStatus}
                  error={formik.errors.groundwater_production?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.groundwater_production.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.groundwater_production.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("groundwater_production"),
                          "groundwater_production"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"groundwater_production"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("groundwater_combined") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.groundwater_combined.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("groundwater_combined")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="groundwater_combined.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.groundwater_combined.value}
                  error={formik.errors.groundwater_combined?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.groundwater_combined?.unit &&
                    formik.touched.groundwater_combined?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.groundwater_combined.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("groundwater_combined").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "groundwater_combined.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "groundwater_combined.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "groundwater_combined.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.groundwater_combined.unit}
                    error={
                      !!formik.errors.groundwater_combined?.unit &&
                      !!formik.touched.groundwater_combined?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.groundwater_combined?.unit &&
                        formik.touched.groundwater_combined?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="groundwater_combined.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "groundwater_combined.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.groundwater_combined.approvalStatus}
                  error={formik.errors.groundwater_combined?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.groundwater_combined.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.groundwater.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("groundwater_combined"),
                          "groundwater_combined"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"groundwater_combined"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("domestic_groundwater_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.domestic_groundwater_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("domestic_groundwater_cost")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="domestic_groundwater_cost.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.domestic_groundwater_cost.value}
                  error={formik.errors.domestic_groundwater_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.domestic_groundwater_cost?.unit &&
                    formik.touched.domestic_groundwater_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.domestic_groundwater_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "domestic_groundwater_cost"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "domestic_groundwater_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "domestic_groundwater_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "domestic_groundwater_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.domestic_groundwater_cost.unit}
                    error={
                      !!formik.errors.domestic_groundwater_cost?.unit &&
                      !!formik.touched.domestic_groundwater_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.domestic_groundwater_cost?.unit &&
                        formik.touched.domestic_groundwater_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="domestic_groundwater_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "domestic_groundwater_cost.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.domestic_groundwater_cost.approvalStatus}
                  error={
                    formik.errors.domestic_groundwater_cost?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.domestic_groundwater_cost.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("domestic_groundwater_cost"),
                          "domestic_groundwater_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"domestic_groundwater_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("groundwater_production_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.groundwater_production_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("groundwater_production_cost")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="groundwater_production_cost.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.groundwater_production_cost.value}
                  error={formik.errors.groundwater_production_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.groundwater_production_cost?.unit &&
                    formik.touched.groundwater_production_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.groundwater_production_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "groundwater_production_cost"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "groundwater_production_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "groundwater_production_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "groundwater_production_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.groundwater_production_cost.unit}
                    error={
                      !!formik.errors.groundwater_production_cost?.unit &&
                      !!formik.touched.groundwater_production_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.groundwater_production_cost?.unit &&
                        formik.touched.groundwater_production_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="groundwater_production_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "groundwater_production_cost.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.groundwater_production_cost.approvalStatus
                  }
                  error={
                    formik.errors.groundwater_production_cost?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.groundwater_production_cost.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("groundwater_production_cost"),
                          "groundwater_production_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"groundwater_production_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("groundwater_combined_cost") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.groundwater_combined_cost.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("groundwater_combined_cost")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="groundwater_combined_cost.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.groundwater_combined_cost.value}
                  error={formik.errors.groundwater_combined_cost?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.groundwater_combined_cost?.unit &&
                    formik.touched.groundwater_combined_cost?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.groundwater_combined_cost.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits(
                      "groundwater_combined_cost"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "groundwater_combined_cost.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "groundwater_combined_cost.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "groundwater_combined_cost.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.groundwater_combined_cost.unit}
                    error={
                      !!formik.errors.groundwater_combined_cost?.unit &&
                      !!formik.touched.groundwater_combined_cost?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.groundwater_combined_cost?.unit &&
                        formik.touched.groundwater_combined_cost?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="groundwater_combined_cost.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "groundwater_combined_cost.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.groundwater_combined_cost.approvalStatus}
                  error={
                    formik.errors.groundwater_combined_cost?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.groundwater_combined_cost.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("groundwater_combined_cost"),
                          "groundwater_combined_cost"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"groundwater_combined_cost"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("rainwater") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.rainwater.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("rainwater")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="rainwater.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.rainwater.value}
                  error={formik.errors.rainwater?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.rainwater?.unit &&
                    formik.touched.rainwater?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.rainwater.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("rainwater").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("rainwater.unit", data.value);
                      formik.setFieldTouched("rainwater.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("rainwater.unit", undefined);
                      }
                    }}
                    value={formik.values.rainwater.unit}
                    error={
                      !!formik.errors.rainwater?.unit &&
                      !!formik.touched.rainwater?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.rainwater?.unit &&
                        formik.touched.rainwater?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="rainwater.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("rainwater.approvalStatus", data.value)
                  }
                  value={formik.values.rainwater.approvalStatus}
                  error={formik.errors.rainwater?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.rainwater.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(t("rainwater"), "rainwater");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"rainwater"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("surface_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.surface_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("surface_water")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="surface_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.surface_water.value}
                  error={formik.errors.surface_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.surface_water?.unit &&
                    formik.touched.surface_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.surface_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("surface_water").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("surface_water.unit", data.value);
                      formik.setFieldTouched("surface_water.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("surface_water.unit", undefined);
                      }
                    }}
                    value={formik.values.surface_water.unit}
                    error={
                      !!formik.errors.surface_water?.unit &&
                      !!formik.touched.surface_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.surface_water?.unit &&
                        formik.touched.surface_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="surface_water.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "surface_water.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.surface_water.approvalStatus}
                  error={formik.errors.surface_water?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.surface_water.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(t("surface_water"), "surface_water");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"surface_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("distilled_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.distilled_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("distilled_water")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="distilled_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.distilled_water.value}
                  error={formik.errors.distilled_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.distilled_water?.unit &&
                    formik.touched.distilled_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.distilled_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("distilled_water").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("distilled_water.unit", data.value);
                      formik.setFieldTouched(
                        "distilled_water.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("distilled_water.unit", undefined);
                      }
                    }}
                    value={formik.values.distilled_water.unit}
                    error={
                      !!formik.errors.distilled_water?.unit &&
                      !!formik.touched.distilled_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.distilled_water?.unit &&
                        formik.touched.distilled_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="distilled_water.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "distilled_water.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.distilled_water.approvalStatus}
                  error={formik.errors.distilled_water?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.distilled_water.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("distilled_water"),
                          "distilled_water"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"distilled_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("reused_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.reused_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("reused_water")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="reused_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.reused_water.value}
                  error={formik.errors.reused_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.reused_water?.unit &&
                    formik.touched.reused_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.reused_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("reused_water").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("reused_water.unit", data.value);
                      formik.setFieldTouched("reused_water.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("reused_water.unit", undefined);
                      }
                    }}
                    value={formik.values.reused_water.unit}
                    error={
                      !!formik.errors.reused_water?.unit &&
                      !!formik.touched.reused_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.reused_water?.unit &&
                        formik.touched.reused_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="reused_water.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "reused_water.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.reused_water.approvalStatus}
                  error={formik.errors.reused_water?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.reused_water.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(t("reused_water"), "reused_water");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"reused_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("recycled_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.recycled_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("recycled_water")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="recycled_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.recycled_water.value}
                  error={formik.errors.recycled_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.recycled_water?.unit &&
                    formik.touched.recycled_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.recycled_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("recycled_water").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue("recycled_water.unit", data.value);
                      formik.setFieldTouched(
                        "recycled_water.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("recycled_water.unit", undefined);
                      }
                    }}
                    value={formik.values.recycled_water.unit}
                    error={
                      !!formik.errors.recycled_water?.unit &&
                      !!formik.touched.recycled_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.recycled_water?.unit &&
                        formik.touched.recycled_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="recycled_water.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "recycled_water.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.recycled_water.approvalStatus}
                  error={formik.errors.recycled_water?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.recycled_water.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(t("recycled_water"), "recycled_water");
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"recycled_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("steam_condensed_water") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.steam_condensed_water.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("steam_condensed_water")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="steam_condensed_water.value"
                  onChange={formik.handleChange}
                  onFocus={handleFocusNumberInput}
                  value={formik.values.steam_condensed_water.value}
                  error={formik.errors.steam_condensed_water?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.steam_condensed_water?.unit &&
                    formik.touched.steam_condensed_water?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.steam_condensed_water.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineWaterUnits("steam_condensed_water").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!unitEditEnabled}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "steam_condensed_water.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "steam_condensed_water.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "steam_condensed_water.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.steam_condensed_water.unit}
                    error={
                      !!formik.errors.steam_condensed_water?.unit &&
                      !!formik.touched.steam_condensed_water?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.steam_condensed_water?.unit &&
                        formik.touched.steam_condensed_water?.unit
                          ? "red"
                          : undefined,
                    }}
                    name="steam_condensed_water.unit"
                  />
                </div>
                {/* {formik.values.days_total.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "steam_condensed_water.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.steam_condensed_water.approvalStatus}
                  error={formik.errors.steam_condensed_water?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.steam_condensed_water.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.total_water_consumed_per_unit_produced.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content="Añadir"
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateWater(
                          t("steam_condensed_water"),
                          "steam_condensed_water"
                        );
                      }}
                    >
                      <img src={commentIcon} alt="comment" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
                    </Button>
                  }
                />

                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"steam_condensed_water"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <BasicModal
        show={showModal}
        onClose={() => setShowModal(false)} // cerrar desde aquí
        title={titleModal}
        size="tiny"
        closeOnDimmerClick={false} // evita cierre al hacer clic fuera
        closeOnEscape={false} // opcional
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Comments
            formik={formik}
            fieldName={fieldName}
            onClose={() => setShowModal(false)}
            onReload={onReload}
            waterForm={waterForm}
            user={user}
            t={t}
          />
        </div>
      </BasicModal>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginRight: 20,
          marginTop: 20,
          alignItems: "center",
        }}
      >

        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!waterForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      {/* Modal de carga de factura de agua */}
      <Modal
        open={showUploadModal}
        onClose={() => !invoiceLoading && setShowUploadModal(false)}
        size="small"
        closeOnDimmerClick={!invoiceLoading}
        className="invoice-reader-modal"
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {t("read_water_invoice") || "Leer factura de agua"}
        </Modal.Header>
        <Modal.Content>
          <InvoiceDropzone
            onFiles={processInvoiceFiles}
            loading={invoiceLoading}
            t={t}
            inputRef={invoiceInputRef}
            onInputChange={handleInvoiceFileChange}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>
            {t("cancel")}
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Modal preview de datos extraídos de factura de agua */}
      <Modal
        open={showInvoiceModal}
        onClose={() => { setShowInvoiceModal(false); setBulkSaveResults(null); setApplyWarning(null); }}
        size="small"
        closeOnDimmerClick={false}
        className="invoice-preview-modal"
      >
        <Modal.Header>
          <Icon name="file alternate outline" /> {t("extracted_water_invoice_data") || "Datos extraídos de factura de agua"}
        </Modal.Header>
        <Modal.Content scrolling>
          {invoiceResults.length > 0 && (() => {
            const sorted = [...invoiceResults].sort((a, b) => {
              if (a.error && !b.error) return 1;
              if (!a.error && b.error) return -1;
              const yearDiff = (b.year || 0) - (a.year || 0);
              if (yearDiff !== 0) return yearDiff;
              return (b.period || 0) - (a.period || 0);
            });

            const groups = [];
            const groupMap = new Map();
            sorted.forEach(r => {
              const key = r.error ? "__errors__" : (r.year && r.period ? `${r.year}-${r.period}` : "__unknown__");
              if (!groupMap.has(key)) {
                groupMap.set(key, { key, year: r.year, period: r.period, isError: !!r.error, isUnknown: !r.year || !r.period, rows: [] });
                groups.push(groupMap.get(key));
              }
              groupMap.get(key).rows.push(r);
            });

            const MONTH_NAMES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

            return (
              <div className="invoice-reader-preview">
                <Message info size="small" style={{ marginBottom: "0.75rem" }}>
                  <Icon name="info circle" />
                  {t("review_invoice_instructions") || "Aplicá las filas que querés incluir, luego hacé clic en Guardar."}
                </Message>
                {invoiceResults.some((r) => r.needsReview) && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {`Se detectaron ${invoiceResults.find((r) => r.needsReview)?.pagesDetected} páginas pero solo se pudo extraer 1 factura. Revisá los datos con cuidado antes de guardar — puede haber varios meses mezclados en una sola fila.`}
                  </Message>
                )}
                {invoicePeriodMismatch && (
                  <Message warning size="small" style={{ marginBottom: "0.75rem" }}>
                    <Icon name="warning sign" />
                    {"Las facturas detectadas son de períodos distintos — revisá que cada fila vaya al mes correcto antes de aplicar."}
                  </Message>
                )}
                <Table size="small" compact>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("water_volume") || "Volumen (m³)"}</Table.HeaderCell>
                      <Table.HeaderCell>{t("cost") || "Costo"}</Table.HeaderCell>
                      <Table.HeaderCell></Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {groups.map(group => (
                      <React.Fragment key={group.key}>
                        <Table.Row>
                          <Table.Cell
                            colSpan={4}
                            style={{
                              background: group.isError ? "#fff0f0" : "#f0f4f9",
                              padding: "5px 10px",
                              borderTop: "2px solid #d0dce8",
                            }}
                          >
                            <Icon
                              name={group.isError ? "exclamation triangle" : "calendar alternate outline"}
                              style={{ color: group.isError ? "#c0392b" : "#648EBC" }}
                            />
                            <strong style={{ fontSize: "0.88em", color: group.isError ? "#c0392b" : "#2c5282" }}>
                              {group.isError
                                ? (t("errors") || "Errores")
                                : group.isUnknown
                                  ? (t("period_not_detected") || "Período no detectado")
                                  : `${MONTH_NAMES[(group.period || 1) - 1]} ${group.year}`}
                            </strong>
                            <span style={{ marginLeft: "8px", fontSize: "0.78em", color: "#888" }}>
                              ({group.rows.length} {group.rows.length === 1 ? (t("file") || "archivo") : (t("files") || "archivos")})
                            </span>
                          </Table.Cell>
                        </Table.Row>
                        {group.rows.map((r, i) => (
                          <Table.Row key={r._rowId || i} negative={!!r.error}>
                            <Table.Cell>
                              <Icon name="paperclip" />
                              <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                              {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                              {r.sourceType && r.sourceType !== "municipal" && (
                                <span style={{ marginLeft: "0.4rem", background: "#f3e8d8", color: "#8a5a1e", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600 }}>
                                  {r.sourceType === "groundwater"
                                    ? (t("source_type_groundwater") || "Agua subterránea")
                                    : (t(r.sourceType) || r.sourceType)}
                                </span>
                              )}
                            </Table.Cell>
                            <Table.Cell>{r.error ? <span style={{color:"red"}}>{r.error}</span> : r.volume != null ? <strong>{formatInvoiceQuantity(r.volume, language)} m³</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                            <Table.Cell>
                              {r.error ? "—" : r.cost != null ? (
                                <>
                                  <strong style={{ whiteSpace: "nowrap" }}>{invoiceCurrencySymbol(r.currency)} {formatInvoiceAmount(r.cost, r.currency, language)}</strong>
                                  {r.currency && <span style={INVOICE_CURRENCY_BADGE_STYLE}>{r.currency}</span>}
                                </>
                              ) : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}
                            </Table.Cell>
                            <Table.Cell style={{ width: "13em", minWidth: "13em" }}>
                              {!r.error && (() => {
                                const btnStyle = { padding: "0.35em 0.75em", lineHeight: 1, width: "100%", whiteSpace: "nowrap" };
                                if (appliedIndexes.has(r._rowId)) {
                                  return (
                                    <Button size="mini" color="green" style={btnStyle} onClick={() => handleUnapplyInvoiceData(r)} title={t("unapply") || "Desaplicar"}>
                                      <Icon name="check" /> {t("applied") || "Aplicado"} <Icon name="times" style={{ marginLeft: "0.3em", marginRight: 0, opacity: 0.7 }} />
                                    </Button>
                                  );
                                }

                                const family = familyOf(r.sourceType);
                                const target = resolveTargetFields(r.sourceType);

                                // Fuente simple detectada pero el campo no está activo en la
                                // configuración del sitio: no hay dónde aplicarla.
                                if (target.mode === "blocked") {
                                  return (
                                    <span style={{ fontSize: "0.78em", color: "#a05a2c" }} title={t("source_field_not_configured") || "Campo no configurado para este sitio"}>
                                      <Icon name="ban" /> {t(target.valueField) || target.valueField}
                                    </span>
                                  );
                                }

                                // Combinada está desactivada y doméstica + producción están
                                // activas a la vez: no hay forma de saber a cuál corresponde
                                // la factura sin preguntar.
                                if (target.mode === "choice") {
                                  const choice = sourceChoices[r._rowId];
                                  return (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "0.4em",
                                        background: "#f0f4f9",
                                        border: "1px solid #d0dce8",
                                        borderRadius: "8px",
                                        padding: "0.5em",
                                      }}
                                    >
                                      <Dropdown
                                        icon={null}
                                        placeholder={t("select_source") || "¿Doméstica o Producción?"}
                                        selection
                                        options={family === "groundwater" ? [
                                          { key: "domestic", text: t("domestic_groundwater") || "Doméstica (pozo)", value: "domestic" },
                                          { key: "production", text: t("groundwater_production") || "Producción (pozo)", value: "production" },
                                        ] : [
                                          { key: "domestic", text: t("water_domestic_municipal_network") || "Doméstica", value: "domestic" },
                                          { key: "production", text: t("municipal_network_water_production") || "Producción", value: "production" },
                                        ]}
                                        value={choice || ""}
                                        onChange={(_, d) => setSourceChoices(prev => ({ ...prev, [r._rowId]: d.value }))}
                                        style={{ width: "100%", fontSize: "0.8em", minHeight: "auto" }}
                                      />
                                      <Button size="mini" color="teal" style={btnStyle} disabled={!choice} onClick={() => handleApplyInvoiceData(r)}>
                                        <Icon name="check" /> {t("apply") || "Aplicar"}
                                      </Button>
                                    </div>
                                  );
                                }

                                // Doméstica o Producción sin ambigüedad (la otra está inactiva):
                                // aplicación directa, sin multi-medidor.
                                if (target.mode === "direct") {
                                  return (
                                    <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="check" /> {t("apply") || "Aplicar"}
                                    </Button>
                                  );
                                }

                                const periodKey = r.period && r.year
                                  ? `${parseInt(r.year, 10)}-${PERIOD_NUM_TO_NAME[String(r.period)] || r.period}`
                                  : null;
                                const hasConflict = periodKey && invoiceResults.some(
                                  other => other._rowId !== r._rowId &&
                                    appliedIndexes.has(other._rowId) &&
                                    other.period && other.year &&
                                    familyOf(other.sourceType) === family &&
                                    `${parseInt(other.year, 10)}-${PERIOD_NUM_TO_NAME[String(other.period)] || other.period}` === periodKey
                                );
                                return hasConflict
                                  ? <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "0.4em",
                                        background: "#f0f4f9",
                                        border: "1px solid #d0dce8",
                                        borderRadius: "8px",
                                        padding: "0.5em",
                                      }}
                                    >
                                      <Dropdown
                                        icon={null}
                                        placeholder={t("meter_name") || "Nombre del medidor"}
                                        search
                                        selection
                                        allowAdditions
                                        additionLabel={`${t("add_new_meter") || "Nuevo medidor"}: `}
                                        options={existingMeterNames.map((name) => ({ key: name, text: name, value: name }))}
                                        value={meterNames[r._rowId] || ""}
                                        onAddItem={(_, d) => setExistingMeterNames((prev) => [...prev, d.value].sort())}
                                        onChange={(_, d) => setMeterNames(prev => ({ ...prev, [r._rowId]: d.value }))}
                                        style={{ width: "100%", fontSize: "0.8em", minHeight: "auto" }}
                                      />
                                      <Button size="mini" color="blue" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                        <Icon name="plus" /> {t("add_as_meter_record") || "Agregar como registro"}
                                      </Button>
                                    </div>
                                  : <Button size="mini" color="teal" style={btnStyle} onClick={() => handleApplyInvoiceData(r)}>
                                      <Icon name="check" /> {t("apply") || "Aplicar"}
                                    </Button>;
                              })()}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                      </React.Fragment>
                    ))}
                  </Table.Body>
                </Table>
              </div>
            );
          })()}

          {applyWarning && (
            <Message warning size="small" style={{ marginTop: "0.75rem" }}>
              <Icon name="warning sign" />
              {applyWarning}
            </Message>
          )}

          <div ref={bulkSaveResultsRef} />
          {bulkSaveResults && (() => {
            const renderFileList = (items, color) => (
              <ul style={{ margin: "4px 0 0 16px", padding: 0, listStyle: "none" }}>
                {items.map((item, i) => (
                  <li key={i} style={{ fontSize: "0.82em", color: "#555", marginBottom: 2 }}>
                    <Icon name="file alternate outline" style={{ color }} />
                    <strong>{t(item.period)} {item.year}</strong>
                    {item.filename && <span style={{ marginLeft: 6, color: "#888" }}>— {item.filename}</span>}
                    {item.msg && <span style={{ marginLeft: 6, color: "#c0392b" }}>({item.msg})</span>}
                  </li>
                ))}
              </ul>
            );
            return (
              <Message
                success={bulkSaveResults.errors.length === 0 && bulkSaveResults.saved.length > 0}
                warning={bulkSaveResults.errors.length > 0 || bulkSaveResults.saved.length === 0}
                style={{ marginTop: "1rem" }}
              >
                <Message.Header>{t("bulk_save_result") || "Resultado del guardado"}</Message.Header>
                {bulkSaveResults.saved.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="check circle" color="green" />
                    <strong style={{ color: "#27ae60" }}>
                      {bulkSaveResults.saved.length} {t("bulk_saved_ok") || "guardados correctamente"}
                    </strong>
                    {renderFileList(bulkSaveResults.saved, "#27ae60")}
                  </div>
                )}
                {bulkSaveResults.skipped.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="warning sign" color="yellow" />
                    <strong style={{ color: "#e67e22" }}>
                      {bulkSaveResults.skipped.length} {t("bulk_skipped") || "omitidos (período ya existía)"}
                    </strong>
                    {renderFileList(bulkSaveResults.skipped, "#e67e22")}
                  </div>
                )}
                {bulkSaveResults.errors.length > 0 && (
                  <div style={{ marginTop: "0.5rem" }}>
                    <Icon name="times circle" color="red" />
                    <strong style={{ color: "#c0392b" }}>
                      {bulkSaveResults.errors.length} {t("bulk_errors") || "con error al guardar"}
                    </strong>
                    {renderFileList(bulkSaveResults.errors, "#c0392b")}
                  </div>
                )}
              </Message>
            );
          })()}
        </Modal.Content>
        <Modal.Actions>
          {!bulkSaveResults && appliedIndexes.size > 0 && (
            <Button
              primary
              onClick={handleSaveAllInvoiceData}
              loading={bulkSaveLoading}
              disabled={bulkSaveLoading}
            >
              <Icon name="save" /> {`${t("save_applied") || "Guardar"} (${appliedIndexes.size})`}
            </Button>
          )}
          <Button
            secondary
            onClick={() => {
              setShowInvoiceModal(false);
              setBulkSaveResults(null);
              setApplyWarning(null);
              if (bulkSaveResults?.saved?.length > 0) goBack();
            }}
            disabled={bulkSaveLoading}
          >
            <Icon name="close" /> {t("close") || "Cerrar"}
          </Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true,
    disabled: loading,
    noClick: true,
    noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`,
        borderRadius: "12px",
        padding: "2.5rem 1.5rem",
        minHeight: "260px",
        textAlign: "center",
        cursor: loading ? "not-allowed" : "pointer",
        background: isDragOver ? "#f0f6ff" : "#fafafa",
        transition: "all 0.2s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
      }}
    >
      <input {...getInputProps()} />
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt"
        multiple
        style={{ display: "none" }}
        onChange={onInputChange}
      />
      {loading ? (
        <>
          <img
            src={`${process.env.PUBLIC_URL}/favicon.png`}
            alt="sustemia"
            className="invoice-dropzone-spinner"
          />
          <p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p>
        </>
      ) : (
        <>
          <Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>
            {t("drag_drop_files")}
          </p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}>
            <Icon name="folder open outline" />
            {t("select_files")}
          </Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>
            {t("supported_formats")}
          </p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted /> {console.log(review)}
        </React.Fragment>
      ))}


      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div
          style={{
            display: "flex",
            gap: "1em",
            marginTop: "1em",
            justifyContent: "center",
          }}
        >
          <Button
            type="button" // importante para no disparar submit
            content="Añadir"
            primary
            size="small"
            style={{ minWidth: 100 }}
            onClick={handleAddComment}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            size="small"
            style={{ minWidth: 100 }}
            onClick={onClose}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      setFileUrl(fileName); // Construye la URL del archivo
      (async () => {
        try {
          const response = await waterFormController.getFileApi(fileUniqueName);
          setFileUrl(response); // Construye la URL del archivo
          //console.log(setFileUrl);
          //setMessage(response.message);
        } catch (error) {
          //setMessage('Error al elimianr el archivo');
        }
      })();
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          circular
          color="red"
          className="file-action-btn"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button circular primary icon className="file-action-btn">
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await waterFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            onClick={handleButtonClick}
            style={{ marginTop: "10px" }}
            color={files.length > 0 ? "green" : "grey"}
          >
            <img src={vector71Icon} alt="upload" style={{ width: 14, height: 14, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />

      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            onClick={closeModal}
            style={{ marginTop: "10px" }}
          >
            <img src={viewIcon} alt="view" style={{ width: 16, height: 16, filter: "brightness(0) invert(1)" }} />
          </Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">
                  Archivos nuevos (se guardarán al enviar)
                </Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        circular
                        color="blue"
                        className="file-action-btn"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        circular
                        color="red"
                        className="file-action-btn"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter(
                            (_, i) => i !== index
                          );
                          setNewFiles({
                            ...newFiles,
                            [field]: updatedNewFiles,
                          });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 &&
              (!newFiles[field] || newFiles[field].length === 0) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5em",
                    color: "#9e9e9e",
                    padding: "2em 0",
                  }}
                >
                  <Icon name="file outline" size="big" />
                  <span>No se encontraron archivos subidos.</span>
                </div>
              )}
          </List>
          <div className="view-files-actions" style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary size="small" style={{ minWidth: 100 }} onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
